import Link from 'next/link';

import { formatRank } from '@flipster/features/src/trading-leaderboard-page/bunja';
import { LeaderboardTierIcon } from '@flipster/features/src/trading-leaderboard-page/shared/tier-icon';
import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { menuItemCssRaw } from './shared/css';
import RedDot from './shared/red-dot';
import { LeaderboardNav, LinkNav } from './shared/state';

interface NavItemProps {
  item: LinkNav | LeaderboardNav;
  onClick: () => void;
}
export const NavItem = ({ item, onClick }: NavItemProps) => {
  switch (item.type) {
    case 'link':
      return <LinkNavItem item={item} onClick={onClick} />;
    case 'leaderboard':
      return <LeaderboardNavItem item={item} onClick={onClick} />;
    default:
      item satisfies never;
      return null;
  }
};

interface LinkNavItemProps {
  item: LinkNav;
  onClick: () => void;
}
const LinkNavItem = ({ item, onClick }: LinkNavItemProps) => {
  return (
    <IsomorphicLink href={item.url} newTab={item.newTab} onClick={onClick} className={css(menuItemCssRaw)}>
      <RedDot redDotKey={item.redDotKey}>{item.label}</RedDot>
    </IsomorphicLink>
  );
};

interface LeaderboardNavItemProps {
  item: LeaderboardNav;
  onClick: () => void;
}
const LeaderboardNavItem = ({ item, onClick }: LeaderboardNavItemProps) => {
  return (
    <Link href={item.url} onClick={onClick} className={css(menuItemCssRaw)}>
      <p>{item.label}</p>
      {item.ranking && (
        <div className={hstack({ gap: 4 })}>
          <LeaderboardTierIcon tier={item.ranking.tier} size={20} />
          {item.ranking.rankingStatus === 'UNRANKED' || item.ranking.rank == null ? (
            <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
              <FormattedMessage id='Autogen_common.r251126.s_Unranked' />
            </p>
          ) : (
            <Badge color='neutral'>{formatRank(item.ranking.rank, item.ranking.lastRank)}</Badge>
          )}
        </div>
      )}
    </Link>
  );
};
